import DwFormField from '@ui/formfield/DwFormField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
const BookAnAppointmentDateSelection = (props) => {
    const { t } = useTranslation();
    const { formdef, days, values, form } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: classNames({ 'col-12': props.fullWidth }, { 'col-6': !props.fullWidth }) },
                React.createElement(DwFormField, { def: formdef, name: "date", type: "select", requiredLabel: true, disabled: props.disabled, options: [{ value: '', label: t('label.select') }].concat(Object.keys(days).map((d) => {
                        let label = d;
                        let available = days[d].find((d) => d.disabled == false);
                        // console.log(days[values.date]);
                        if (window.locale === 'ja_JP') {
                            label = d.replace('.', '年').replace('.', '月').concat('日');
                        }
                        return { label: label, value: d, disabled: !available };
                    })), onChange: form.mutators.resetHours })),
            React.createElement("div", { className: classNames({ 'col-12': props.fullWidth }, { 'col-6': !props.fullWidth }) },
                React.createElement(DwFormField, { def: formdef, name: "hour", type: "select", requiredLabel: true, disabled: !(values === null || values === void 0 ? void 0 : values.date) || props.disabled, options: days[values.date] ? [{ value: '', label: t('label.select') }].concat(days[values.date]) : [{ value: '', label: t('label.select') }] })))));
};
export default BookAnAppointmentDateSelection;
